export enum CustomAppEvents {
  CLARITY_LOADED = 'clarityLoaded',
  ONE_TRUST_LOADED = 'oneTrustLoaded',
}
